import { getStyleMapProperty, mapPopupContent } from '../LeafletStyleHelpers';

const styleMap = new Map([
  ['Arbutus_DouglasFir', { fillColor: '#b7484b', legendText: 'Arbutus - Douglas Fir' }],
  ['Arbutus_GarryOak', { fillColor: '#987db7', legendText: 'Arbutus - Garry Oak' }],
  ['Arbutus_LodgePine_DouglasFir', { fillColor: '#e15989', legendText: 'Arbutus - Lodgepole Pine - Douglas-fir' }],
  ['BlackCottonwood_Crabapple_Willow', { fillColor: '#c43c39', legendText: 'Black Cottonwood - Crabapple - Willow' }],
  ['FreshWater_Wetland', { fillColor: '#91522d', legendText: 'Fresh-water Wetland' }],
  ['GarrOak', { fillColor: '#85b66f', legendText: 'Garry Oak' }],
  ['GarryOak_Arbutus', { fillColor: '#d5b43c', legendText: 'Garry Oak - Arbutus' }],
  ['Salal_Lichen', { fillColor: '#8d5a99', legendText: 'Salal - Lichen' }],
  ['Salal_OG', { fillColor: '#ff9e17', legendText: 'Salal - Oregon Grape' }],
  ['SF_Salal', { fillColor: '#e77148', legendText: 'Swordfern - Salal' }],
  ['SW_Wetland', { fillColor: '#becf50', legendText: 'Salt-water Wetland' }],
  ['Swo_Hem_AF', { fillColor: '#e5b636', legendText: 'Swordfern - Hemlock - Amabilis-fir' }],
  ['SwordFern', { fillColor: '#beb297', legendText: 'Swordfern' }],
]);

const layer = {
  title: 'Native Plant Ecosystems',
  description: [
    {type: 'p', content: 'This map outlines the native plant communities of the Greater Victoria Metropolitan area and Capital Regional District. Source: S, Eis, Canadian Forestry Service Cartography, (n.d.), Native Plant Communities Victoria Metropolitan Area Capital Regional District British Columbia [Map], 1:100,000 Resource Analysis Unit, British Columbia Environment and Land Use Secretariat.'},
  ],
  data: require('../geojson/NativePlantEcosystems.geojson'),
  shape: 'polygon',
  symbology: 'classified',
  styleMap: styleMap,
  options: {
    style: function (feature) {
      const baseStyle = {
        stroke: false,
        dashArray: '',
        lineCap: 'butt',
        lineJoin: 'miter',
        weight: 1,
        fill: true,
        fillOpacity: 0.7,
      }
      return {
        ...baseStyle,
        fillColor: getStyleMapProperty(
          'fillColor',
          feature.properties.ecosystem,
          styleMap
        ),
        color: getStyleMapProperty(
          'fillColor',
          feature.properties.ecosystem,
          styleMap
        ),
      }
    },
    onEachFeature: (f,l) => {
      l.bindPopup(mapPopupContent(
        'Native Plant Ecosystems',
        f.properties.ecosystem_name,
        ), {offset: [0,-6]});
    }
  },
}

export default layer;